import script from "./DDL.vue?vue&type=script&setup=true&lang=js"
export * from "./DDL.vue?vue&type=script&setup=true&lang=js"

import "./DDL.vue?vue&type=style&index=0&id=15ef501c&lang=css"

const __exports__ = script;

export default __exports__